import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';


import image01 from '../assets/CardsImages/card-2-img/img_16.jpg'
import image02 from '../assets/CardsImages/card-2-img/img_17.jpg'
import image03 from '../assets/CardsImages/card-2-img/img_18.jpg'
import image04 from '../assets/CardsImages/card-2-img/img_19.jpg'
import image05 from '../assets/CardsImages/card-2-img/img_20.jpg'
import image06 from '../assets/CardsImages/card-2-img/img_21.jpg'
import image07 from '../assets/CardsImages/card-2-img/img_30.jpg'
import image08 from '../assets/CardsImages/card-2-img/img_23.jpg'
import image09 from '../assets/CardsImages/card-2-img/img_24.jpg'
import image10 from '../assets/CardsImages/card-2-img/img_18.jpg'
import image11 from '../assets/CardsImages/card-2-img/img_26.jpg'
import image12 from '../assets/CardsImages/card-2-img/img_27.jpg'
import image13 from '../assets/CardsImages/card-2-img/img_28.jpg'
import image14 from '../assets/CardsImages/card-2-img/img_29.jpg'
import image15 from '../assets/CardsImages/card-2-img/img_30.jpg'
import image16 from '../assets/CardsImages/card-2-img/img_17.jpg'

const Card02 = () => {



  const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image

  const images = [
    image01,
    image02,
    image03,
    image04,
    image05,
    image06,
    image07,
    image08,
    image09,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16


    // Add the rest of the images here...
  ];

  const handleImageClick = (image) => {
    setSelectedImage(image); // Set the selected image
  };

  const handleClose = () => {
    setSelectedImage(null); // Clear the selected image
  };




  return (

    <div>
      {/* <Navbar /> */}
      <div className="container mx-auto px-4 py-8 my-10">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-purple-800 mb-4">Distillation Column Maintenance & Inspection Job</h1>
          <p className="text-lg text-blue-800">
            Maintenance and inspection of distillation columns are essential to ensure their safe and efficient operation in a chemical or petrochemical plant. Regular maintenance and inspections can help prevent issues, extend the lifespan of the equipment, and minimize unplanned shutdowns.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">1. Planning and Preparation</h2>
            <p className="text-gray-700">
              Develop a maintenance and inspection schedule, taking into account the manufacturer's recommendations and industry standards. Determine the scope of work, including the specific components to be inspected or replaced. Ensure that necessary permits, safety measures, and isolation procedures are in place before starting the work.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">2. Safety Precautions</h2>
            <p className="text-gray-700">
              Prioritize safety throughout the maintenance and inspection process. Ensure that personnel are properly trained and equipped with the required personal protective equipment (PPE). Lock out and tag out (LOTO) procedures should be followed to isolate the column from the process and energy sources.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">3. Shutdown and Isolation</h2>
            <p className="text-gray-700">
              Plan and execute a controlled shutdown of the distillation column. Isolate the column from the process to prevent the flow of materials through it during maintenance.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">4. Visual Inspection</h2>
            <p className="text-gray-700">
              Perform a visual inspection of the exterior of the column, looking for signs of corrosion, leaks, or damage.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">5. Internal Inspection</h2>
            <p className="text-gray-700">
              If necessary, inspect the internals of the distillation column, such as trays, packings, distributors, and other components. Use inspection tools, cameras, or robotic equipment to access and assess the internals.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">6. Non-Destructive Testing (NDT)</h2>
            <p className="text-gray-700">
              Utilize non-destructive testing methods like ultrasonic testing, radiographic testing, or magnetic particle testing to check for material defects or corrosion.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">7. Corrosion and Wear Analysis</h2>
            <p className="text-gray-700">
              Evaluate the condition of the column's materials and identify areas of corrosion or wear. Assess the remaining thickness of the column walls and internals to determine if replacements or repairs are needed.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">8. Repairs and Replacements</h2>
            <p className="text-gray-700">
              Based on inspection findings, schedule and execute necessary repairs or replacements of damaged or deteriorated components. Ensure that all replacements meet industry standards and specifications.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">9. Reassembly and Testing</h2>
            <p className="text-gray-700">
              Reassemble the column internals and components as per the manufacturer's guidelines. Conduct hydrostatic testing or pressure tests to ensure the integrity and tightness of the column.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-purple-800 mb-4">10. Continuous Monitoring</h2>
            <p className="text-gray-700">
              Implement a monitoring and maintenance program to ensure the ongoing efficient operation of the column. Regular inspections and performance assessments are essential.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <h3 className="text-3xl font-bold text-purple-800 mb-4">All Work</h3>
          <p className="text-lg text-blue-800">
            We provide high standard work for your company solutions.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>


                    {/* Modal to show selected image */}
                {selectedImage && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                        <div className="relative">
                            <img
                                src={selectedImage}
                                alt="Selected"
                                className="max-w-full max-h-screen rounded-lg"
                            />
                            <button
                                onClick={handleClose}
                                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                            >
                                ✖
                            </button>
                        </div>
                    </div>
                )}
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Card02;
